import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { UtilService } from '../util.service';
import { UserService } from '../user.service';
import { AccountService } from '../account.service';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthServiceFactory {
    constructor(private util: UtilService,
                private userService: UserService,
                private storageService: StorageService,
                private accountService: AccountService) { }

  createAuthService(): AuthService {
    return new AuthService(this.util, this.storageService, this.userService, this.accountService);
  }
}
